<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" color="secondary" rounded>
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Create Supplier Group',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Supplier Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierGroupForm class="ma-2" ref="form" v-model="form" @submit="handleSubmit"/>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>

    </v-container>
</template>

<script>
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import { mapActions } from 'vuex'
import PAlert from './../../components/common/PAlert.vue';
import PIconBtn from './../../components/common/PIconBtn.vue';
import SupplierGroupForm from './../../components/purchase/SupplierGroupForm';
import { v4 as uuid } from 'uuid';

export default {
    name: "SupplierGroupCreateView",
    components: {
        SupplierGroupForm,
        PIconBtn,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            form: {},
            idempotentKey: null
        }
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            create: "purchase/supplierGroup/create"
        }),
        handleSave() {
            this.$refs.form.submit()
        },
        handleSubmit() {
            this.alert = {...this.alert , value: true, content: "Are you sure you Want to save", callback: this.save}
        },
        handleDiscard() {
            this.$router.push({ name: "SupplierGroupList" })
        },
        save() {
            this.loading = true
            this.create({...this.form, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({text: "Supplier Group Create", color: "success"})
                this.$router.push({name: "SupplierGroupDisplay", params: { id: response.data.id}})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message , color: "error"})
            }).finally(() => {
                this.loading = false
            })
        }
    },
    mounted() {
        this.idempotentKey = uuid()
    }
}
</script>

<style>

</style>